export default __webpack_public_path__ + "images/18108dde728dc704400716b5bba6d31e-rudy-game-solved-header-es.svg";